var SiteConfig = {
  LOGIN_SYSTEM_NAME: "Racing Feed Client",
  LOGIN_PHONE_LINE: 1123,
  USER_ACCESS_SVC: "useraccesssvc",
  RACING_MGMT_SVC: "racingmgmtsvc"
};

export default SiteConfig;
